import "core-js/modules/es.object.freeze";

var _LoadingSpinner;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import ThemeProvider from "../../../theme/ThemeProvider";
import LoadingSpinner from "../../Common/LoadingSpinner";
import Icon from "../../Common/Icon";
import useLoading from './useLoading';
import styles from './Button.scss';
var SIZE = Object.freeze({
  normal: 'normal',
  large: 'large'
});
var STYLE = Object.freeze({
  "default": 'default',
  primary: 'primary',
  secondary: 'secondary',

  /**
   * @deprecated need remove, used only in Media: commentForm,
   */
  text: 'text'
});
var TYPE = Object.freeze({
  button: 'button',
  submit: 'submit',
  reset: 'reset'
});

var ButtonIcon = function ButtonIcon(_ref) {
  var styleType = _ref.styleType,
      isLoading = _ref.isLoading,
      icon = _ref.icon;

  if (isLoading) {
    if (styleType === STYLE.secondary) {
      return /*#__PURE__*/React.createElement(ThemeProvider, {
        theme: "invert",
        className: styles.icon
      }, _LoadingSpinner || (_LoadingSpinner = /*#__PURE__*/React.createElement(LoadingSpinner, null)));
    }

    return /*#__PURE__*/React.createElement(LoadingSpinner, {
      className: styles.icon
    });
  }

  if (icon) {
    return /*#__PURE__*/React.createElement(Icon, {
      name: icon,
      className: styles.icon,
      color: "inherit"
    });
  }

  return null;
};

var Button = function Button(_ref2) {
  var _classnames;

  var className = _ref2.className,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? null : _ref2$children,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? SIZE.normal : _ref2$size,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? TYPE.button : _ref2$type,
      _ref2$styleType = _ref2.styleType,
      styleType = _ref2$styleType === void 0 ? STYLE.secondary : _ref2$styleType,
      _ref2$isDisabled = _ref2.isDisabled,
      isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
      isActive = _ref2.isActive,
      isHover = _ref2.isHover,
      isPressed = _ref2.isPressed,
      isFocus = _ref2.isFocus,
      _ref2$isFullWidth = _ref2.isFullWidth,
      isFullWidth = _ref2$isFullWidth === void 0 ? false : _ref2$isFullWidth,
      icon = _ref2.icon,
      linkTo = _ref2.linkTo,
      linkTarget = _ref2.linkTarget,
      onClick = _ref2.onClick,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading;
  var isLoadingShow = useLoading(isLoading);

  var handleClick = function handleClick(e) {
    if (isLoadingShow || isDisabled || !onClick) {
      return;
    }

    onClick(e);
  };

  var content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonIcon, {
    styleType: styleType,
    isLoading: isLoadingShow,
    icon: icon
  }), !!children && /*#__PURE__*/React.createElement("span", {
    className: styles.content
  }, children));
  var buttonClassName = classnames(styles.button, className, styles[styleType], [styles[size]], (_classnames = {}, _defineProperty(_classnames, styles.active, isActive), _defineProperty(_classnames, styles.pressed, isPressed), _defineProperty(_classnames, styles.focus, isFocus), _defineProperty(_classnames, styles.hover, isHover), _defineProperty(_classnames, styles.full, isFullWidth), _defineProperty(_classnames, styles.square, !children), _defineProperty(_classnames, styles.loadingWithText, !icon && isLoadingShow && !!children), _classnames));

  if (linkTo && !isDisabled && !isLoadingShow) {
    return /*#__PURE__*/React.createElement("a", {
      className: buttonClassName,
      href: linkTo,
      target: linkTarget
    }, content);
  }

  return /*#__PURE__*/React.createElement("button", {
    className: buttonClassName,
    type: type,
    disabled: isDisabled,
    onClick: handleClick
  }, content);
};

Button.SIZE = SIZE;
Button.STYLE = STYLE;
export default Button;